export default {"src":"/_next/static/media/graph.af72f1e6.svg","height":24,"width":24};